/**
 * Run an asynchronous queue pass one at a time without dropping a request
 * that arrives while the current pass is active.
 */
export function createSingleFlightDrain(
  runPass: () => Promise<void>,
): { request: () => Promise<void> } {
  let running: Promise<void> | null = null;
  let rerunRequested = false;

  const request = (): Promise<void> => {
    rerunRequested = true;
    if (running) return running;

    const passLoop = async () => {
      while (rerunRequested) {
        rerunRequested = false;
        await runPass();
      }
    };

    running = passLoop().finally(async () => {
      running = null;
      if (rerunRequested) await request();
    });
    return running;
  };

  return { request };
}
